import { Outlet } from 'react-router';
import { CreateProjectProvider } from './CreateProjectContext';

export default function CreateProjectLayout() {
  return (
    <CreateProjectProvider>
      <Outlet />
    </CreateProjectProvider>
  );
}
